var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getItemTableContainerClass},[_c('ItemTable',{ref:"itemTable",attrs:{"boundItemsUrl":_vm.boundItemsUrl,"columns":_vm.columns,"handleBulkDelete":_vm.handleBulkDelete,"handleRowClick":_vm.showCommandResultDetails,"hasSelectColumn":true,"inDetailsAsidePanel":!_vm.inMainPanel,"itemType":_vm.itemType,"keepFresh":true,"selectionItemText":{
      label: 'selected',
      plural: 'command results',
      singular: 'command result',
    },"showBound":false,"showBulkDelete":!_vm.isCommandRunner,"showSearchForm":true,"viewport":_vm.viewport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }